import React, { useState } from "react";
import DefaultInput from "../../components/form/DefaultInput";
import DefaultDatePicker from "../../components/form/DefaultDatePicker";
import Buttons from "../../components/form/Buttons";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import { CONFIG } from "../../config";

const InternationalOrders = () => {
	const [value, setValue] = useState<number | undefined>(undefined);
	const [totalOrderNo, setTotalOrderNo] = useState<number | undefined>(
		undefined
	);
	const [date, setDate] = useState<Date | undefined>(undefined);

	const handleOrderNoChange = (e: any) => {
		const value = e.target.value;

		if (/^\d*$/.test(value)) {
			setTotalOrderNo(value);
		}
	};

	const saveChanges = async () => {
		if (!totalOrderNo || (totalOrderNo && totalOrderNo <= 0)) {
			toast.error(
				"Ju lutemi shkruani një numër të vlefshëm dhe pozitiv për 'Numri i Porosive'."
			);
			return;
		}

		if (!value || value <= 0) {
			toast.error(
				"Ju lutemi shkruani një vlerë të vlefshme dhe pozitive për 'Vlera'."
			);
			return;
		}

		if (!date) {
			toast.error("Ju lutemi zgjidhni një datë të vlefshme.");
			return;
		}

		const fakeData = {
			date: date.toISOString(),
			value: Number(value),
			nrOfOrders: Number(totalOrderNo),
		};

		try {
			const response = await api.get("OrdersF2/generate", {
				params: fakeData,
			});
		} catch (error) {
			console.log(error);
		} finally {
			cleanState();
		}
	};

	const cleanState = () => {
		setValue(undefined);
		setTotalOrderNo(undefined);
		setDate(undefined);
	};
	return (
		<>
			<div className="flex flex-col gap-8">
				<div className="flex flex-wrap justify-around item-center">
					<DefaultInput
						placeholder="Shenoni Vleren"
						label="Vlera"
						value={value}
						onChange={(e: any) => setValue(e.target.value)}
						className="registerInput"
						prefix={CONFIG?.CURRENCY}
						type="number"
					/>
					<DefaultInput
						placeholder="Sheno..."
						label="Numri i porosive"
						value={totalOrderNo}
						onChange={handleOrderNoChange}
						className="registerInput"
						type="number"
					/>
					<DefaultDatePicker
						label="Data"
						value={date}
						onChange={(date: any) => setDate(date)}
						width={172}
						className="registerInput"
					/>
				</div>
				<Buttons
					button2Text="Ruaj"
					button1Text="Mbyll"
					onButton1Click={cleanState}
					onButton2Click={saveChanges}
				/>
			</div>
		</>
	);
};

export default InternationalOrders;
